/**
 * Le contexte d'apparence et ses deux lecteurs.
 *
 * Séparé de `FournisseurApparence.tsx` pour une raison pratique : un fichier
 * qui exporte à la fois un composant et des fonctions casse le rechargement à
 * chaud de Vite (`react-refresh/only-export-components`). Le fournisseur reste
 * un fichier de composant, les hooks vivent ici.
 */

import { createContext, use } from 'react'

import type { ApparencePublique } from './api'

export const ContexteApparence = createContext<ApparencePublique | null>(null)

/**
 * L'apparence du théâtre, ou `null` tant qu'elle n'est pas connue.
 *
 * `null` n'est pas une erreur : c'est « les valeurs d'origine s'appliquent ».
 * Les appelants affichent alors leur propre repli (le nom générique de
 * `lib/theatre`, aucun logo). Un écran qui attendrait les couleurs pour
 * s'afficher serait un mauvais échange.
 */
export function useApparence(): ApparencePublique | null {
  return use(ContexteApparence)
}

/**
 * Le logo du théâtre, prêt à poser dans un `<img>`, ou `null` (PER-02).
 * Raccourci commode : c'est la question la plus posée au contexte.
 */
export function useLogoTheatre(): string | null {
  return use(ContexteApparence)?.logo ?? null
}
